import api from '@/api/tecnologico.api'

let servicio = {}

servicio.conAdmin = (idUsuario) => {
  return api.get(`/usuariossistemas/conadmin/${idUsuario}`)
}

servicio.guardar = (data) => {
  return api.post('/usuariossistemas/guardar', data)
}

servicio.cambiarEstatus = (data) => {
  return api.post('/usuariossistemas/cambiarestatus', data)
}

servicio.bitacora = (idCliente) => {
  const params = idCliente ? { idCliente } : {}
  return api.get('/usuariossistemas/bitacora', { params })
}

export default servicio
